/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }
(function() {
  let messaging = undefined;
  let permissionGranted = undefined;
  const Cls = (Utility.Messaging = class Messaging {
    static initClass() {
      messaging = null;
      permissionGranted = false;

      this.notificationStatus = status => {
        return $.ajax({
          url: "/messaging_notification_status",
          data: {
            status
          },
          headers: {
            "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
          },
          type: 'POST',
          cache: false,
          dataType: 'script'
        });
      };

      this.displayMessage = (title, body, url, fromUserId, messageId) => {
        Utility.Messaging.popupMessage(title, body, url);

        if (url.match(/messages/) || url.match(/alerts/)) {
          return Turbo.visit(window.location.href)
        }
      };

      this.updateBell = () => {
        return $.get($('#admin-alerts').data('url'), null, null, 'script');
      };

      this.popupMessage = (title, body, url) => {
        if (url.match(/messages/) || url.match(/mentions/)) {
          Utility.Messaging.updateBell();
        }

        if (url.length > 0) {
          title = `<a class="no-underline text-gray-900" href='${url}' data-remote=true>${title}</a>`;
          body = `<a class="no-underline text-gray-500" href='${url}' data-remote=true>${body}</a>`;
        }

        window.dispatchEvent(new CustomEvent("add-message", { detail: {
          type: 'info',
          title,
          details: body,
          url
        }}))
      };

      this.refreshAlerts = (html, count) => {
        window.dispatchEvent(new CustomEvent("update-notification-count", { detail: { count }}))

        // iOS APP ONLY
        if ((typeof window.JsInterface !== "undefined") && (typeof JsInterface.setLauncherBadgeCount === "function")) {
          return JsInterface.setLauncherBadgeCount(count);
        }
      };
    }

    static sendTokenToServer(token) {
      return $.ajax({
        url: "/messaging_tokens",
        type: 'POST',
        data: {
          messaging_token: {
            token
          }
        },
        headers: {
          "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
        },
        cache: false,
        dataType: 'script'
      });
    }

    static deleteTokenFromServerAndSignOut(token) {
      return $.ajax({
        url: "/session",
        type: 'DELETE',
        data: {
          messaging_token: token
        },
        headers: {
          "X-CSRF-TOKEN": document.querySelector('meta[name=csrf-token]')?.content
        },
        cache: false,
        dataType: 'script'
      });
    }

    static signOut() {
      console.log('hit')
      if ((messaging !== null) && permissionGranted) {
        console.log('messing no null')
        return messaging.getToken()
          .then(currentToken => {
           return messaging.deleteToken(currentToken).then(() => { return currentToken })
          })
          .then(currentToken => {
            Utility.Messaging.deleteTokenFromServerAndSignOut(currentToken)
            console.log('Token deleted on sign out')
            return Promise.resolve(true)
          }).catch(err => { return console.log(err); });
      } else {
        console.log('messing null')
        return Utility.Messaging.deleteTokenFromServerAndSignOut('no_token');
      }
    }

    static prepareWeb() {
      if (!window.PushManager) {
        console.log("POLLING");
        return $("[data-autorefresh]").each(function() {
          clearInterval($(this).reloadInterval);
          const url = $(this).data('url');
          return $(this).reloadInterval = setInterval((() => $.get(url, null, null, 'script')), 1000 * $(this).data('autorefresh'));
        });
      } else {
        console.log("EVENT DRIVEN");
        const firebaseConfig = {
          apiKey: $('#fcm').data('config').apiKey,
          authDomain: $('#fcm').data('config').authDomain,
          databaseURL: $('#fcm').data('config').databaseUrl,
          projectId: $('#fcm').data('config').projectId,
          storageBucket: '',
          messagingSenderId: $('#fcm').data('config').messageSenderId,
          appId: $('#fcm').data('config').appId
        };

        if (firebase.apps.length === 0) {
          firebase.initializeApp(firebaseConfig);
        }
        messaging = firebase.messaging();
        messaging.usePublicVapidKey($('#fcm').data('config').vapidPublicKey);

        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            console.log('Notification permission granted.');
            permissionGranted = true;
            // Get Instance ID token. Initially this makes a network call, once retrieved
            // subsequent calls to getToken will return from cache.
            return messaging.getToken().then(currentToken => {
              if (currentToken) {
                Utility.Messaging.sendTokenToServer(currentToken);
                return console.log('Token sent to server.');
              } else {
                // Show permission request.
                return console.log('No Instance ID token available. Request permission to generate one.');
              }
          }).catch(err => {
              console.log('An error occurred while retrieving token.', err);
              return Utility.Messaging.popupMessage('An error occurred while retrieving token.', err, '');
            });
          }
        });
              // setTokenSentToServer(false)

        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(() => {
          return messaging.getToken().then(refreshedToken => {
            console.log('Token refreshed.');
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            // setTokenSentToServer(false)
            return Utility.Messaging.sendTokenToServer(refreshedToken);
        }).catch(err => {
            console.log('Unable to retrieve refreshed token ', err);
            return Utility.Messaging.popupMessage('Unable to retrieve refreshed token.', err, '');

          });
        });
            // showToken('Unable to retrieve refreshed token ', err)

        return messaging.onMessage(payload => {
          console.log('onMessage: ', payload);
          return Utility.Messaging.displayMessage(payload.notification.title, payload.notification.body, payload.data.url, payload.data.fromUserId, payload.data.messageId);
        });
      }
    }
  });
  Cls.initClass();
  return Cls;
})();
